import useStore from '../../../store';



export function startDragging(pieceId, eventData, offset, dragOrigin) {
  const { ref } = useStore.getState();
  const { puzzle } = ref;
  const piece = puzzle.state.pieces[pieceId];
  if (!piece || piece.placed || puzzle.state.draggingPiece) return;
  if (piece.reservedUntil && piece.reservedUntil > Date.now() && piece.reservedBy !== ref.telegram?.activeUserId) {
      console.log(`Piece ${pieceId} is reserved by another user.`);
      return;
  }

  window.croco?.appleHaptic('soft');
  Object.values(puzzle.state.pieces).forEach(p => p.zIndex = p.placed ? 30 : (p.onBoard ? 40 : 10));
  piece.zIndex = 100;

  puzzle.state.draggingPiece = {
      piece,
      pieceId,
      pointerId: eventData.pointerId,
      pointerType: eventData.pointerType,
      button: eventData.button,
      dragOrigin,
      dragStartPos: { x: eventData.clientX, y: eventData.clientY },
      startTime: Date.now(),
      offset: offset || { x: 0, y: 0 },
      touchOffsetY: 0,
   };

  ref.work?.methods?.hostAction('reservePiece', { pieceId });
  ref.puzzle.methods.redraw();
};


export async function stopDragging  (eventData)  {

  const { ref } = useStore.getState();
  const { puzzle } = ref;
  const { config, state } = puzzle;
  const { draggingPiece } = state;
  if (!draggingPiece || eventData.pointerId !== draggingPiece.pointerId) return;

  window.croco?.appleHaptic('soft');
  const pieceId = draggingPiece.pieceId;
  const piece = state.pieces[pieceId];
  if (!piece) {
      puzzle.state.draggingPiece = null;
      puzzle.methods.redraw();
      return;
  }

  const { isQuickTap, insideBoard, isCorrectPosition, boardX, boardY } = await dropCoordinates(pieceId, eventData);

  // --- Проверяем, находится ли указатель НАД КАНВАСОМ ДОСКИ ---
  if (insideBoard){
      if (isCorrectPosition) {
          // Размещаем пазл
          const amount = Object.keys(state.pieces).length;
          ref.work?.methods?.hostAction('placePuzzle', { pieceId, amount });
          puzzle.methods._placePiece(pieceId);
          puzzle.methods.clearTrayGhosts();
      } else {
          // Оставляем на доске
          piece.currentPos = { x: boardX, y: boardY };
          piece.onBoard = true;
          piece.inTray = false;
          ref.work?.methods?.hostAction('releasePiece', { pieceId });
      }
  } else {
      // Отпустили вне канваса доски -> возвращаем в трей
      piece.onBoard = false;
      piece.inTray = true;
      piece.currentPos = null;
      ref.work?.methods?.hostAction('releasePiece', { pieceId });

      
  }

  puzzle.state.draggingPiece = null;
  puzzle.state.finishingRotationPieceId = null;
  puzzle.methods.redraw();

};


async function dropCoordinates(pieceId, eventData) {

  const { ref } = useStore.getState();
  const { puzzle } = ref;
  const { state, config, layout } = puzzle;
  const { draggingPiece } = state;

  const boardTransform = ref.puzzle.boardTransform;
  const boardCanvasRect = ref.puzzle.boardCanvas?.rect; 

  const piece = state.pieces[pieceId];

  const timePassed = Date.now() - draggingPiece.startTime;
  const longTap = timePassed > 250;

  let isQuickTap = !draggingPiece.moved && !longTap && config.game.pieceRotation;
  if (isQuickTap) {
    await quickTapRotation({ ref, draggingPiece, piece, puzzle, pieceId });
  }

  // Координаты указателя относительно КАНВАСА ДОСКИ
  let pointerXOnBoardCanvas = (eventData.clientX - boardCanvasRect.left) / boardTransform.scale;
  let pointerYOnBoardCanvas = (eventData.clientY - boardCanvasRect.top) / boardTransform.scale + draggingPiece.touchOffsetY;


  // INSIDE BOARD LOGIC
  const boardWidth = state.boardDimensions?.width;  
  const boardHeight = state.boardDimensions?.height;

  const trayTop = layout.trayContainer.top;

  const insideBoard = eventData.clientY + draggingPiece.touchOffsetY < trayTop &&
  pointerXOnBoardCanvas >= 0 &&
  pointerXOnBoardCanvas <= boardWidth &&
  pointerYOnBoardCanvas >= 0 &&
  pointerYOnBoardCanvas <= boardHeight


  // IF CORRECT POSITION
  const boardX = pointerXOnBoardCanvas - (draggingPiece.offset.x / boardTransform.scale);
  const boardY = pointerYOnBoardCanvas - (draggingPiece.offset.y / boardTransform.scale);

  // Проверяем близость к правильной позиции
  const isNearCorrectPosition = puzzle.methods.checkPieceProximity(pieceId, { x: boardX / boardWidth, y: boardY / boardHeight } );

  const isCorrectPosition = isNearCorrectPosition && (piece.rotation % 360) === 0;

  if (isCorrectPosition) { isQuickTap = false; }

  return {
    isQuickTap,
    insideBoard,
    isCorrectPosition,
    boardX,
    boardY,
  }

}

export function cancelDragging(pieceId, reason) {
  const { ref } = useStore.getState();
  const { puzzle } = ref;
  const { draggingPiece } = puzzle.state;
  if (!draggingPiece || draggingPiece.pieceId !== pieceId) return;

  puzzle.state.draggingPiece = null;

  const piece = puzzle.state.pieces[pieceId];
  if (!piece) return;

  if (draggingPiece.dragOrigin === 'tray') {
    piece.onBoard = false; piece.inTray = true; piece.currentPos = null;
  } else {
    piece.onBoard = true; piece.inTray = false;
  }
  piece.zIndex = draggingPiece.dragOrigin === 'tray' ? 10 : 40;

  ref.work?.methods?.hostAction('releasePiece', { pieceId });
  puzzle.methods.redraw();
};

export function reserveFromRemote(pieceId, userId) {
  const { ref } = useStore.getState();
  const { puzzle } = ref;
  const piece = puzzle.state.pieces[pieceId];
  if (!piece || piece.placed) return;

  if (piece.reservedBy !== ref.telegram?.activeUserId) {

      const now = Date.now();
      const reservationId = now;

      piece.reserved = reservationId;
      piece.reservedUntil = now + puzzle.config.reserveTimeout;
      piece.reservedBy = userId;

      setTimeout(() => {
        if (
          piece.reserved === reservationId 
          && piece.reservedUntil > Date.now()) {
          puzzle.methods.redraw();
        }
      }, 1000);
  }
};

export function releaseFromRemote(pieceId, userId) {
  const { ref } = useStore.getState();
  const { puzzle } = ref;
  const piece = puzzle.state.pieces[pieceId];
  if (!piece) return;

  if (piece.reservedBy === userId) {

      piece.unreserved = Date.now();
      piece.reserved = 0;
      piece.reservedUntil = 0;
      piece.reservedBy = null;

      puzzle.methods.render();
      setTimeout(() => { puzzle.methods.redraw(); }, 150);
  }
};

export function checkPieceProximity(pieceId, normalizedPos) {
  const { ref } = useStore.getState();

  const { puzzle } = ref;
  const { config, state } = puzzle;
  const { pieces } = state;
  const piece = pieces[pieceId];
  // Используем imageDimensions для расчета относительных размеров
  if (!piece || !state.boardDimensions?.width || !state.imageDimensions?.width) return false;

  const pieceRelWidth = piece.baseDimensions.width / state.imageDimensions.width;
  const pieceRelHeight = piece.baseDimensions.height / state.imageDimensions.height;
  const toleranceFactor = config.game.snapToleranceFactor || 0.5;
  const toleranceX = pieceRelWidth * toleranceFactor;
  const toleranceY = pieceRelHeight * toleranceFactor;

  const correctX = piece.correctPos.x;
  const correctY = piece.correctPos.y;

  const distanceX = Math.abs(normalizedPos.x - correctX);
  const distanceY = Math.abs(normalizedPos.y - correctY);

  return distanceX <= toleranceX && distanceY <= toleranceY;
};

export function placePieceFromRemote(pieceId, userId) {
  const { ref } = useStore.getState();
  const { puzzle } = ref;
  const piece = puzzle.state.pieces[pieceId];
  if (!piece || piece.placed || !puzzle.state.boardDimensions?.width) return;
  ref.puzzle.methods._placePiece(pieceId, userId);
  setTimeout(() => ref.puzzle.methods.clearTrayGhosts(), 100);
};

export function _placePiece(pieceId, userId) {
  const { ref } = useStore.getState();
  const { telegram, puzzle, info, work } = ref;
  const { pieces, boardDimensions, state } = puzzle.state;
  const piece = pieces[pieceId];
  if (!piece || piece.placed || !boardDimensions?.width) return false;

  const placerId = userId || telegram.activeUserId;

  info.game = info.game || {};
  info.game.puzzle = info.game.puzzle || {};
  info.game.puzzle.placedPieces = info.game.puzzle.placedPieces || {};
  info.game.puzzle.placedPieces[pieceId] = { userId: placerId, time: Date.now() };

  Object.assign(piece, {
    currentPos: {
      x: piece.correctPos.x * boardDimensions.width,
      y: piece.correctPos.y * boardDimensions.height,
    },
    placed: true, onBoard: true, inTray: false,
    placedBy: placerId, placedAt: Date.now(),
    highlighted: Date.now() + (ref.puzzle.config.highlightTimeout || 2500),
    zIndex: 30, rotation: 0,
    reserved: 0, reservedUntil: 0, reservedBy: null,
    visible: true,
  });

  puzzle.state.placedPiecesCount = Object.values(pieces).filter(p => p.placed).length;


  setTimeout(() => {
    puzzle.methods.render();
  }, ref.puzzle.config.highlightTimeout - 1000);
  setTimeout(() => {
     if (piece.highlighted) {
         piece.highlighted = 0;
         puzzle.methods.render();
     }
  }, ref.puzzle.config.highlightTimeout);

  window.croco?.appleHaptic('medium');
  puzzle.methods.redraw();
  puzzle.methods.checkCompletion();
  return true;
};

export async function rotateDraggingPiece(event) {

  const store = useStore.getState();
  const { ref } = store;
  const { puzzle } = ref;
  const { state, config } = puzzle;
  const { draggingPiece } = state;
  if (!draggingPiece || !config.game.pieceRotation) return;
  const piece = state.pieces[draggingPiece.pieceId];
  if (!piece || piece.placed) return;
  
  const rotationDirection = event.clientX < store.pointerPosition.x ? -90 : 90;
  
  piece.rotation += rotationDirection;
  puzzle.state.finishingRotationPieceId = puzzle.state.draggingPiece;

  puzzle.methods.render();
  window.croco?.appleHaptic?.('light');

  await new Promise(resolve => setTimeout(resolve, 100));
  puzzle.state.finishingRotationPieceId = null;

};

async function quickTapRotation({ ref, draggingPiece, piece, puzzle, pieceId }) {
  
  if (draggingPiece.button === 0 && draggingPiece.pointerType === 'mouse' && !puzzle.config.isTouchDevice) {
      piece.rotation -= 90;
  } else {
      piece.rotation += 90;
  }

  ref.work?.methods?.hostAction('releasePiece', { pieceId });

  puzzle.state.finishingRotationPieceId = puzzle.state.draggingPiece;
  puzzle.state.draggingPiece = null;
  puzzle.methods.render();

  const mils = draggingPiece.pointerType === 'touch' ? 250 : 100
  await new Promise(resolve => setTimeout(resolve, mils));

  puzzle.state.finishingRotationPieceId = null;
  puzzle.methods.redraw();

}